export const gtmGettySearchClickEvent = (productName: string, query: string) => ({
  event: 'Getty_Image_select',
  eventLabel: `${query}_GettyImage-${productName}}`,
});

export default gtmGettySearchClickEvent;
